import { render, staticRenderFns } from "./InitialProposalListing.vue?vue&type=template&id=360d9ecc"
import script from "./InitialProposalListing.vue?vue&type=script&lang=js"
export * from "./InitialProposalListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports